import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleNav = (href: string) => {
    navigate(href);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <span className="text-background-50 font-heading font-bold text-lg">麻</span>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">麻将竞技资讯</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              传播麻将文化，分享竞技技巧，让每一位麻将爱好者都能在健康环境中享受竞技乐趣。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2">
              {[
                { label: '爆奖案例', href: '/category/baojing-anli' },
                { label: '麻将技巧', href: '/category/majiang-jiqiao' },
                { label: '牌型分析', href: '/category/paixing-fenxi' },
                { label: '新手入门', href: '/category/xinshou-rumen' },
                { label: '赛事资讯', href: '/category/saishi-zixun' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); handleNav(item.href); }}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">热门文章</h4>
            <ul className="space-y-2">
              {[
                { label: '麻将糊了中17万', href: '/article/majiang-hule-zhong-17wan' },
                { label: '清一色碰碰胡技巧', href: '/article/qingyise-pengpenghu-gaoji-jiqiao' },
                { label: '麻将心理战七信号', href: '/article/majiang-xinli-zhan' },
                { label: '2026全国大赛', href: '/article/2026-quanguo-majiang-dasai' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); handleNav(item.href); }}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/about"
                  onClick={(e) => { e.preventDefault(); handleNav('/about'); }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  品牌介绍
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  onClick={(e) => { e.preventDefault(); handleNav('/about'); }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  联系我们
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} 麻将竞技资讯. 本站内容仅供学习交流，倡导健康娱乐。
          </p>
          <div className="flex items-center gap-4">
            <a href="/about" onClick={(e) => { e.preventDefault(); handleNav('/about'); }} className="text-sm text-background-500 hover:text-background-200 transition-colors cursor-pointer">关于我们</a>
            <span className="text-background-600">|</span>
            <a href="/about" onClick={(e) => { e.preventDefault(); handleNav('/about'); }} className="text-sm text-background-500 hover:text-background-200 transition-colors cursor-pointer">联系方式</a>
          </div>
        </div>
      </div>
    </footer>
  );
}